/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Absences_Recurrence_IntervalInputs */

const en_tables_absences_recurrence_interval = /** @type {(inputs: Tables_Absences_Recurrence_IntervalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recurrence Interval`)
};

const de_tables_absences_recurrence_interval = /** @type {(inputs: Tables_Absences_Recurrence_IntervalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholung Intervall`)
};

/**
* | output |
* | --- |
* | "Recurrence Interval" |
*
* @param {Tables_Absences_Recurrence_IntervalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_absences_recurrence_interval = /** @type {((inputs?: Tables_Absences_Recurrence_IntervalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Absences_Recurrence_IntervalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_absences_recurrence_interval(inputs)
	return de_tables_absences_recurrence_interval(inputs)
});